import { SolViewId, SolViewOptions } from '@sol/components';
import { CredentialKeyValueViewOptions } from '../components/view/asm-view-edit-credential-key-value/asm-view-edit-credential-key-value.component';

export class AsmEngagementsViewId {
  public static readonly credentialKeyValue = SolViewId.of<CredentialKeyValueViewOptions>('asm.credentialKeyValue');
  public static readonly engagementIdEdit = SolViewId.of<SolViewOptions>('engagementIdEdit');
}
